export function Checkmark() {
  return (
    <path
      d="M92.583 77.191a1 1 0 00-1.396.23l-9.356 13.046-3.124-3.126a1 1 0 10-1.414 1.414l3.956 3.956a1.018 1.018 0 001.52-.124l10.044-14a1 1 0 00-.23-1.396z"
      fill="var(--color-border-accent)"
    />
  );
}
